import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OrganizationConfiguration from './organization-configuration';
import OrganizationConfigurationDetail from './organization-configuration-detail';
import OrganizationConfigurationUpdate from './organization-configuration-update';
import OrganizationConfigurationDeleteDialog from './organization-configuration-delete-dialog';

const OrganizationConfigurationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OrganizationConfiguration />} />
    <Route path="new" element={<OrganizationConfigurationUpdate />} />
    <Route path=":id">
      <Route index element={<OrganizationConfigurationDetail />} />
      <Route path="edit" element={<OrganizationConfigurationUpdate />} />
      <Route path="delete" element={<OrganizationConfigurationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OrganizationConfigurationRoutes;
